/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GridHeader } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class LayersUploadClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags LayersUpload
   * @summary Импорт поверхностей 2D карт
   * @request POST:/bff/LayersUpload/UploadMap2dFileCollection/project/{projectId}
   * @secure
   */
  layersUploadUploadMap2DFileCollection = (
    projectId: string,
    data: {
      /**
       * Список cвойств для сохранения поверхностей в БД.
       *             Количество и порядок записей должны соответствовать списку файлов
       */
      gridInfoCollection: string
      /** Список файлов для импорта поверхности */
      fileCollection: File[]
    },
    params: RequestParams = {},
  ) =>
    this.http.request<GridHeader[], string>({
      path: `/bff/LayersUpload/UploadMap2dFileCollection/project/${projectId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })
}
